import { queryUrlToObj } from '@/util/router'
import axios, { AxiosInstance } from 'axios'

// @ts-ignore
axios.defaults.withCredentials = true

export class HttpClient {
  protected HTTP!: AxiosInstance
  constructor() {
    this.HTTP = axios.create({
      baseURL: process.env.API_URL,
    })
    this.requestInterceptor()
    this.responseInterceptor()
  }

  private async requestInterceptor() {
    this.HTTP.interceptors.request.use((req) => {
      const token = `${sessionStorage.getItem("token")}`
      if (!!token) {
        req.headers["x-client"] = token
      }
      return req
    })
  }


  private async responseInterceptor() {
    const savePath = () => {
      if (window) {
        let url = new URL(window.location.toString())

        let query = queryUrlToObj(url.search)

        let payload = {
          pathname: url.pathname,
          query,
        }

        sessionStorage.setItem("auth-path", window.btoa(JSON.stringify(payload)))
      }
    }

    this.HTTP.interceptors.response.use((res) => {
      if (res.status == 401 && window.location.pathname != "/auth/login") {
        savePath()
        window.location.pathname = "/auth/login"
      }
      return res
    }, (err) => {
      if (err.response) {
        if ([401].includes(err.response.status)) {
          if (window.location.pathname == "/auth/login") {
            return Promise.reject(err)
          } else {
            if (!["/auth/forgot-password"].includes(window.location.pathname)) {
              sessionStorage.clear()
              window.location.pathname = "/auth/login"
            }

          }
        }
        return Promise.reject(err)
      }
      return Promise.reject(err)
    })
  }

}
